module.exports = __webpack_public_path__ + "img/marketGradeLogo.f3dc817e.svg";